import { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "../../../../utils/axios";
import { meterController } from "../../../../controllers/MeterController";
import SetLoadPolicy from "../Modals/SetLoadPolicy";
import MeterInfoModal from "../../modals/MeterInfoModal";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { Dropdown, Space, Tag } from "antd";
import { TbDotsVertical } from "react-icons/tb";
import { tableCustomStyles } from "../../../../helperFuncs";
import AssignMeter from "../../modals/AssignMeter";
import { CopyOutlined } from "@ant-design/icons";

// Function to generate consistent colors based on string
const generateColorFromString = (str) => {
  // A list of predefined colors to cycle through
  const colors = ["magenta", "red", "volcano", "orange", "geekblue", "purple"];

  // Simple hash function to get a number from a string
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Use the hash to select a color
  const index = Math.abs(hash) % colors.length;
  return colors[index];
};

const AllMeterTable = ({ data }) => {
  const [selectMeter, setselectMeter] = useState(null);
  const [loading, setloading] = useState(null);
  const [openassign, setopenassign] = useState(false);
  const [customer, setcustomer] = useState(null);
  const [loadType, setloadType] = useState(null);
  const [showSet, setshowSet] = useState(false);
  const [serialColorMap, setSerialColorMap] = useState({});

  const [selectedId, setSelectedId] = useState(null);
  const [modal, setModal] = useState(false);
  const userDetials = useSelector((state) => state.userDetails);

  // Create a map of serial numbers to colors and count occurrences
  useEffect(() => {
    if (data && data.length > 0) {
      // First find which serials appear multiple times
      const serialCounts = {};
      const colorMap = {};

      data.forEach((item) => {
        const serial = item.device_serial;
        if (serial) {
          serialCounts[serial] = (serialCounts[serial] || 0) + 1;
        }
      });

      // Assign colors only to serials that appear more than once
      Object.keys(serialCounts).forEach((serial) => {
        if (serialCounts[serial] > 1) {
          colorMap[serial] = generateColorFromString(serial);
        }
      });

      setSerialColorMap(colorMap);
    }
  }, [data]);

  const columns = [
    {
      name: "Meter no",
      center: true,
      selector: (row) => row.meternumber,
      grow: 1,
      sortable: true,
      cell: (row) => (
        <div className="flex items-center justify-center gap-2">
          <span className="text-blue-500">{row.meternumber}</span>
          <CopyOutlined
            className="cursor-pointer text-blue-500"
            style={{ color: "dodgerblue" }}
            onClick={() => {
              navigator.clipboard.writeText(row.meternumber);
              toast.success("Meter number copied to clipboard");
            }}
          />
        </div>
      ),
    },
    {
      name: "Batch No",
      center: true,
      selector: (row) => row.batchid,
      grow: 1,
      sortable: true,
    },
    {
      name: "Serial no",
      center: true,
      selector: (row) => row.device_serial,
      grow: 1,
      sortable: true,
      cell: (row) => {
        // If the serial appears in our color map, it means it's a duplicate
        if (serialColorMap[row.device_serial]) {
          return (
            <Tag color={serialColorMap[row.device_serial]}>
              {row.device_serial}
            </Tag>
          );
        }
        // Otherwise return plain text
        return <span>{row.device_serial}</span>;
      },
    },
    {
      name: "Phase Type",
      center: true,
      selector: (row) => row.phases,
      sortable: true,
    },
    {
      name: "Assigned to",
      center: true,
      selector: (row) => row.assignedto,
      grow: 1,
      sortable: true,
    },
    // {
    //   name: "Model",
    //   center: true,
    //   selector: (row) => row.model,
    //   grow: 1,
    //   sortable: true,
    // },
    // {
    //   name: "Date registered",
    //   center: true,
    //   selector: (row) => row.dateregistered,
    //   grow: 1,
    //   cell: (item) => {
    //     return (
    //       <div className="flex items-center">
    //         <div className="text-[13px]">
    //           {moment(item.dateregistered).format("YYYY-MM-DD")}
    //         </div>
    //       </div>
    //     );
    //   },
    //   sortable: true,
    // },
    {
      name: "Action",
      selector: (row) => row.siteid,
      center: true,
      grow: 1,
      cell: (item) => {
        return (
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  label:
                    item?.assignedto === "-" ? (
                      <div
                        onClick={() => {
                          setSelectedId(item?.meternumber);
                          setModal(true);
                        }}
                        className="text-[12px]"
                      >
                        View details
                      </div>
                    ) : (
                      <Link
                        to={`/meter-details/${item.assignedto}/${item.meternumber}`}
                        className="text-[12px]"
                      >
                        View details
                      </Link>
                    ),
                },
                {
                  key: "2",
                  onClick: () => {
                    setselectMeter(item.meternumber);
                    setopenassign(true);
                  },
                  label: <div className="text-[12px]">Assign meter</div>,
                },
              ],
            }}
            placement="bottom"
            arrow
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <TbDotsVertical color="black" />
              </Space>
            </a>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <>
      {/* <AssignMeter open={openassign} setopen={setopenassign} user={null} /> */}
      <div
        style={{
          borderTop: "1px solid #eee",
        }}
      >
        {openassign && (
          <AssignMeter open={openassign} setopen={setopenassign} user={null} />
        )}
        {modal && (
          <MeterInfoModal
            setopen={setModal}
            open={modal}
            meterNumber={selectedId}
          />
        )}
        {showSet && (
          <SetLoadPolicy meterId={selectMeter} closeModal={setshowSet} />
        )}
        <DataTable
          columns={columns}
          data={data}
          pagination
          progressPending={loading}
          paginationPerPage={30}
          customStyles={tableCustomStyles}
        />
      </div>
    </>
  );
};

export default AllMeterTable;
